import React, { useEffect, useState } from "react";
import "./addStudent.scss";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { getTimezoneOption } from "../../globals/common_utilities/timezoneListing";
import InputTags from "../common/InputTags";
import Dropdown from "../common/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import {
  isEmpty,
  validateEmail,
  validatePhone,
  validateName,
  validateScript,
  validateSkills,
} from "../../globals/common_utilities/utilities";
import {
  Redux_location,
  Redux_primary_aws,
  Redux_add_training_center,
} from "../../redux/forms";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import api_call from "../../globals/common_utilities/axios_old";
import download_icon from "../../Images/download_icon.svg";
import upload_icon from "../../Images/upload_icon.svg";
import { Box, Rating } from "@mui/material";
import * as XLSX from "xlsx";
import EDIT from "../../Images/formEdit.png";
import {
  API,
  FOMRS,
  STATUS,
  ROLE,
  APP_ROUTES,
} from "../../globals/constants/index";
import green_icon from "../../globals/assets/green_computer.svg";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import CLOSE from "../../Images/close.svg";
import _ from "lodash";
import Cookies from "universal-cookie";

const AddTrainingCenterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [getTimeZoneList, setTimeZoneList] = useState();
  const [type, setType] = useState(state?.type || FOMRS.ADD);
  const [studioId, setSudioId] = useState(
    state?.id || "963d81bc-f265-4405-96bf-6743cd07cbb2"
  );
  const [instructorData, setInstructorData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [traininig_center_list, setTraining_center_list] = useState([]);
  const [editCheckbox, setEditCheckbox] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const api_res = useSelector((state) => {
    return state.add_training_center.Response;
  });
  const { loginResponse } = useSelector((state) => {
    return state.login;
  });

  const [aws_region, setAws_region] = useState();
  const [location, setLocation_list] = useState();
  const [uploadFilterData, setUploadFilterData] = useState([]);

  console.log("api_res--------->>", api_res);

  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");

  const [formField, setFormField] = useState({
    name: "",
    username: "",
    email_id: "",
    location_id: "",
    studio_id: studio_id,
    role_id: 4,
    contact_no: "",
    short_information: "",
    is_active: true,
  });
  const [formField_error, setFormFild_error] = useState({
    name_error: false,
    username_error: false,
    email_id_error: false,
    location_id_error: false,
    studio_id_error: false,
    contact_no_error: false,
    short_information_error: false,
    is_active: true,
  });

  useEffect(() => {
    TimeZoneFun();
    getAWSLocationFun();
    getLocationFun();
    if (type === FOMRS.VIEW || type === FOMRS.EDIT) viewForm();
  }, []);
  const getToster = (res) => {
    if (res?.status === 200) {
      toast.success(
        `${
          type === FOMRS.EDIT
            ? "Student updated successfully"
            : "Student created successfully"
        }`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
      gotolistingPage();
      // } else if (res?.status === 409) {
    } else if (res?.status === 409) {
      toast.error(res.err.data.msg, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      toast.error(`something gone Wrong !!`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
    // }
  };

  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    setTimeZoneList(timezone);
  };

  const getLocationFun = async () => {
    const Response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_LOCATION
      }`
      // API.BASE_URL.STUDIO + API.END_POINTS.GET_LOCATION
    );
    if (Response.status === 200) {
      setLocation_list(
        Response.data?.data?.rows.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.code,
        }))
      );
    } else {
      setLocation_list([]);
    }
  };

  const getAWSLocationFun = async () => {
    let params = {
      cloud_type: "AWS",
    };
    const Response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_AWS_REGION
      }`,
      params
      // API.BASE_URL.STUDIO + API.END_POINTS.GET_AWS_REGION
    );
    if (Response.status === 200) {
      setAws_region(
        Response.data?.data?.rows.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.region_name,
        }))
      );
    } else {
      setAws_region([]);
    }
  };
  const traininingCenterFun = async () => {
    if (role_code === ROLE.ADMIN) {
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
        }
      );
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
      }
    } else {
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
          studio_id: studio_id,
        }
      );
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
      } else {
        setTraining_center_list([]);
      }
    }
  };
  const isValid = () => {
    console.log(
      "formField.skills------->.",
      formField.skills,
      "",
      formField.instructor_can_be_training_admin_checkbox
    );
    if (
      !isEmpty(formField.contact_no) &&
      !isEmpty(formField.email_id) &&
      !isEmpty(formField.location_id) &&
      !isEmpty(formField.name) &&
      !isEmpty(formField.short_information) &&
      !isEmpty(formField.studio_id) &&
      !isEmpty(formField.username) &&
      validateEmail(formField.email_id) &&
      validatePhone(formField.contact_no) &&
      validateScript(formField.name) &&
      validateScript(formField.location_id) &&
      validateScript(formField.short_information) &&
      validateScript(formField.studio_id) &&
      validateScript(formField.username)
    ) {
      return true;
    } else {
      return false;
    }
  };

  // const uploadValid = () => {
  // 	let temp = [...uploadedFile];
  // 	console.log('item.zone---------->>', temp);
  // 	let valid = true;
  // 	temp = temp.map((item) => {
  // 		if (item.zone === '' || item.zone === null || item.zone === undefined) {
  // 			valid = false;
  // 			toast.success('Please select timezones in bulk upload', {
  // 				position: 'bottom-right',
  // 				autoClose: 3000,
  // 				hideProgressBar: true,
  // 				closeOnClick: true,
  // 				pauseOnHover: true,
  // 				draggable: true,
  // 				progress: undefined,
  // 			});
  // 		}
  // 	});
  // 	return valid;
  // };

  const onSubmit = async () => {
    // let temp = [
    // 	...uploadedFile,
    // 	{
    // 		contact_no: formField.contact_no,
    // 		email_id: formField.email_id,
    // 		name: formField.contact_person_name,
    // 		username: formField.username,
    // 		short_information: formField.about_training_center,
    // 		skills: JSON.stringify(formField.skills),
    // 		zone: formField.time_zone,
    // 	},
    // ];
    // console.log('temp----------->.', temp);
    if (await isValid()) {
      let bodyParam = {
        name: formField.name,
        username: formField.username,
        email_id: formField.email_id,
        location_id: formField.location_id,
        studio_id: formField.studio_id,
        role_id: 4,
        contact_no: formField.contact_no,
        short_information: formField.short_information,
        is_active: true,
      };
      let response = "";
      if (type === FOMRS.ADD) {
        let createdBy = {
          id: id,
          name: name,
        };
        bodyParam.createdBy = createdBy;
        console.log("bodyParam----------->.", bodyParam);
      } else {
        let createdBy = {
          id: id,
          name: name,
        };
        bodyParam.createdBy = createdBy;
      }
      console.log("reuqrest -------->>", bodyParam);
      // return
      if (type === FOMRS.ADD) {
        setShowLoader(true);
        response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
            API.END_POINTS.STUDENT_USER_DELETE
          }`,
          // API.BASE_URL.STUDIO + API.END_POINTS.TRAININGCENTER_ENDPOINT,
          {},
          {},
          bodyParam
        );
      } else if (type === FOMRS.EDIT) {
        setShowLoader(true);
        response = await api_call(
          "PUT",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
            API.END_POINTS.STUDENT_USER_DELETE
          }?id=${studioId}`,
          {},
          {},
          bodyParam
        );
      }
      setShowLoader(false);
      getToster(response);
    } else {
      setFormFild_error(() => {
        return {
          ...formField_error,
          name_error:
            isEmpty(formField.contact_person_name) ||
            !validateScript(formField.contact_person_name),
          Training_center_name_error:
            isEmpty(formField.Training_center_name) ||
            !validateScript(formField.Training_center_name),
          contact_no_error:
            isEmpty(formField.contact_no) ||
            !validatePhone(formField.contact_no) ||
            !validateScript(formField.contact_no),
          email_id_error:
            isEmpty(formField.email_id) ||
            !validateEmail(formField.email_id) ||
            !validateScript(formField.email_id),
          short_information_error:
            isEmpty(formField.short_information) ||
            !validateScript(formField.short_information),
          username_error:
            isEmpty(formField.username) || !validateScript(formField.username),

          location_id_error:
            isEmpty(formField.location_id) ||
            !validateScript(formField.short_information_error),
        };
      });
    }
  };

  const timezone_fun = (e) => {
    let data1 = e.value.split("$");
    setFormField({ ...formField, time_zone: data1[0] });
    setFormFild_error({
      ...formField_error,
      time_zone_error: false,
    });
  };
  const location_fun = (e) => {
    console.log("e", e);
    setFormField({ ...formField, location_id: e.value });
    setFormFild_error({
      ...formField_error,
      location_id_error: false,
    });
  };

  const onTimeZoneChange = async (e, i, data) => {
    let tempData = [...uploadedFile];
    let data1 = e.value.split("$");
    tempData[i].zone = data1[0];
    setUploadedFile(tempData);
  };

  const viewForm = async () => {
    let params = { id: studioId };
    setShowLoader(true);
    const { status, data } = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
        API.END_POINTS.STUDENTBYID
      }`,
      params
    );
    if (status === 200) {
      setShowLoader(false);
      let studentData = data?.data?.result?.users?.filter(
        (value) => value.email_id === data?.data?.result?.email
      );
      setUploadedFile(
        data?.data?.result?.users.filter(
          (value) => value.email_id !== data?.data?.result?.email
        )
      );
      setFormField({
        ...formField,
        name: data?.data?.name,
        username: data?.data?.username,
        email_id: data?.data?.email_id,
        location_id: data?.data?.location?.id,
        studio_id: data?.data?.studio_id,
        role_id: 4,
        contact_no: data?.data?.contact_no,
        short_information: data?.data?.short_information,
        is_active: true,
      });
    } else {
      setUploadedFile([]);
    }
  };

  const view_secondary = async (value) => {
    return aws_region.map((data) => {
      if (data.value == value) {
        console.log("data === value-------->>", data.label);

        return data;
      }
    });
  };

  // const validateColumFile = (csv) => {
  // 	var lines = csv.split('\n');
  // 	let validation = true;
  // 	const contact_regex = /^[0-9]*(?:\.\d{1,2})?$/;
  // 	var headers = lines[0].split(',');
  // 	if (lines.length > 1) {
  // 		for (var i = 1; i < lines.length - 1; i++) {
  // 			var obj = {};
  // 			var currentline = lines[i].split(',');

  // 			for (var k = 0; k < headers.length; k++) {
  // 				obj[headers[k]] = currentline[k]?.trim();
  // 			}
  // 			if (obj.name === '') {
  // 				validation = false;
  // 				setErrorMessage(`Name field data incorrect or empty`);

  // 				break;
  // 			} else if (obj.email_id === '') {
  // 				validation = false;
  // 				setErrorMessage(`email field data incorrect or empty`);

  // 				break;
  // 			} else if (obj.contact_no === '') {
  // 				validation = false;
  // 				setErrorMessage(`contact no field data incorrect or empty`);

  // 				break;
  // 			} else if (obj.short_information === '') {
  // 				validation = false;
  // 				setErrorMessage(`short information field data incorrect or empty`);

  // 				break;
  // 			} else if (obj.location === '') {
  // 				validation = false;
  // 				setErrorMessage(`location field data incorrect or empty`);

  // 				break;
  // 			} else if (!validateScript(obj.name?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`name field data incorrect `);

  // 				break;
  // 			} else if (!contact_regex.test(obj.contact_no?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`contact no field data incorrect `);

  // 				break;
  // 			} else if (!validateScript(obj.short_information?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`short information field data incorrect `);

  // 				break;
  // 			} else if (!validateScript(obj.location?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`location field data incorrect `);

  // 				break;
  // 			} else if (!validateEmail(obj.email_id?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`email field data incorrect `);

  // 				break;
  // 			} else if (!validateSkills(obj.skills?.trim())) {
  // 				validation = false;
  // 				setErrorMessage(`skills field data incorrect `);

  // 				break;
  // 			} else {
  // 				validation = true;
  // 			}
  // 			console.log('obj', obj);
  // 		}
  // 		return validation;

  // 		//return result; //JavaScript object
  // 	} else {
  // 		validation = false;
  // 		setErrorMessage(`Blank File with No Records`);
  // 		return validation;
  // 	}
  // 	//JSON
  // };

  // const validateFile = (csv) => {
  // 	var lines = csv.split('\n');
  // 	let validation = true;

  // 	var result = [
  // 		'name',
  // 		'email_id',
  // 		'contact_no',
  // 		'skills',
  // 		'short_information',
  // 	];

  // 	var headers = lines[0].split(',');

  // 	for (var j = 0; j < result.length; j++) {
  // 		if (headers.includes(result[j])) {
  // 			validation = true;
  // 		} else {
  // 			setErrorMessage(`${result[j]} field is missing`);
  // 			validation = false;
  // 			break;
  // 		}
  // 	}
  // 	return validation; //JSON
  // };

  // const onFileChange = (e) => {
  // 	// setState({ selectedFile: e.target.files[0] });
  // 	console.log('eeeee:::', e);
  // 	var f = e.target.files[0];
  // 	var file = e.target.files[0];
  // 	console.log('fffff:::', f);
  // 	console.log('file  :::', file);
  // 	var filename = file.name ? file.name : '';
  // 	var regex = new RegExp('(.*?).(csv)$');
  // 	if (regex.test(filename)) {
  // 		const reader = new FileReader();
  // 		reader.onload = (evt) => {
  // 			// evt = on_file_select event
  // 			/* Parse data */
  // 			const bstr = evt.target.result;
  // 			const wb = XLSX.read(bstr, { type: 'binary' });
  // 			/* Get first worksheet */
  // 			const wsname = wb.SheetNames[0];
  // 			const ws = wb.Sheets[wsname];
  // 			/* Convert array of arrays */
  // 			const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
  // 			// convertToJson(data)
  // 			if (validateFile(data) && validateColumFile(data)) {
  // 				// toast.success("File Uploaded Successfully ", {
  // 				//   position: "bottom-right",
  // 				//   autoClose: 3000,
  // 				//   hideProgressBar: true,
  // 				//   closeOnClick: true,
  // 				//   pauseOnHover: true,
  // 				//   draggable: true,
  // 				//   progress: undefined,
  // 				//   className: "green-background",
  // 				// });
  // 				let convertedData = [...JSON.parse(convertToJson(data))];
  // 				convertedData = convertedData.map((item) => {
  // 					let temp = JSON.stringify(
  // 						item.skills.replaceAll('|', ',').trim().split(',')
  // 					);
  // 					item = {
  // 						...item,
  // 						skills: temp,
  // 						zone: '',
  // 					};
  // 					return item;
  // 				});
  // 				const instructor = [
  // 					...instructorData,
  // 					...uploadedFile,
  // 					...convertedData,
  // 				];
  // 				// setInstructorData(instructor);
  // 				// setUploadFilterData(instructor);
  // 				setUploadedFile(_.unionBy(instructor, 'email_id'));
  // 			} else {
  // 				toast.success(`${errorMessage}`, {
  // 					position: 'bottom-right',
  // 					autoClose: 3000,
  // 					hideProgressBar: true,
  // 					closeOnClick: true,
  // 					pauseOnHover: true,
  // 					draggable: true,
  // 					progress: undefined,
  // 				});
  // 			}
  // 		};

  // 		reader.readAsBinaryString(f);
  // 	} else {
  // 		toast.success(`Please select csv file`, {
  // 			position: 'bottom-right',
  // 			autoClose: 3000,
  // 			hideProgressBar: true,
  // 			closeOnClick: true,
  // 			pauseOnHover: true,
  // 			draggable: true,
  // 			progress: undefined,
  // 		});
  // 	}
  // 	e.target.value = null;
  // 	// ReactGA.event(GA_TAG_LIST.ADMINADDSTUDIO.BROWSE);
  // };
  // const convertToJson = (csv) => {
  // 	var lines = csv.split('\n');

  // 	var result = [];

  // 	var headers = lines[0].split(',');

  // 	for (var i = 1; i < lines.length; i++) {
  // 		var obj = {};
  // 		var currentline = lines[i].split(',');

  // 		for (var j = 0; j < headers.length; j++) {
  // 			obj[headers[j]] = currentline[j]?.trim();
  // 		}
  // 		const arr1 = instructorData.filter((d) => d.email_id === obj.email_id);
  // 		if (obj.name === '' || arr1.length > 0) {
  // 		} else {
  // 			result.push(obj);
  // 		}
  // 	}

  // 	const key = 'email_id';
  // 	const arrayUniqueByKey = [
  // 		...new Map(result.map((item) => [item[key], item])).values(),
  // 	];
  // 	return JSON.stringify(arrayUniqueByKey);
  // };

  const onFileChange = (e) => {
    // this.setState({ selectedFile: e.target.files[0] });
    var f = e.target.files[0];
    var file = e.target.files[0];
    console.log("file", file);
    var filename = file.name;
    // eslint-disable-next-line no-useless-escape
    var regex = new RegExp("(.*?).(csv)$");
    if (regex.test(filename)) {
      const reader = new FileReader();

      reader.onload = (evt) => {
        // evt = on_file_select event
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        console.log("dataaaa", data);
        // this.convertToJson(data)
        if (validateFile(data) && validateColumFile(data)) {
          toast.success("File uploaded successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });

          this.setState((state) => {
            const uploadData = [
              ...state.uploadData,
              ...JSON.parse(this.convertToJson(data)),
            ];

            return {
              uploadData: uploadData,
            };
          });
          this.setState({
            uploadFilterData: this.state.uploadData,
          });
          document.getElementById("file-upload").value = "";
        } else {
          toast.error(`${this.state.errorMessage}`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          document.getElementById("file-upload").value = "";
        }
      };

      reader.readAsBinaryString(f);
    } else {
      toast.error(`Please select csv file`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };
  const convertToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j]?.trim();
      }

      if (obj.name === "") {
      } else {
        result.push(obj);
      }
    }
    const key = "email_id";
    const arrayUniqueByKey = [
      ...new Map(result.map((item) => [item[key], item])).values(),
    ];
    //return result; //JavaScript object
    return JSON.stringify(arrayUniqueByKey); //JSON
  };
  const training_center_fun = (e) => {
    setFormField({ ...formField, Training_center_name: e.value });
    setFormFild_error({
      ...formField_error,
      Training_center_name_error: false,
    });
  };
  const openfile = () => {
    document.getElementById("file-upload").click();
  };
  const validateFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;

    var result = [
      "name",
      "email_id",
      "contact_no",
      "country_name",
      "location",
      "short_information",
    ];

    var headers = lines[0].split(",");

    for (var j = 0; j < result.length; j++) {
      if (headers.includes(result[j])) {
        validation = true;
      } else {
        this.setState({
          errorMessage: `${result[j]} field is missing`,
        });
        validation = false;
        break;
      }
    }
    return validation; //JSON
  };
  const validateColumFile = (csv) => {
    var lines = csv.split("\n");
    let validation = true;
    const contact_regex = /^[0-9]*(?:\.\d{1,2})?$/;

    var headers = lines[0].split(",");
    if (lines.length > 2) {
      for (var i = 1; i < lines.length - 1; i++) {
        var obj = {};
        var currentline = lines[i].split(",");

        for (var k = 0; k < headers.length; k++) {
          obj[headers[k]] = currentline[k]?.trim();
        }
        if (obj.name === "") {
          validation = false;
          this.setState({
            errorMessage: `Name field data incorrect or empty`,
          });
          break;
        } else if (obj.email_id === "") {
          validation = false;
          this.setState({
            errorMessage: `email field data incorrect or empty`,
          });
          break;
        } else if (!this.validateScript(obj.name?.trim())) {
          validation = false;
          this.setState({
            errorMessage: `name field data incorrect `,
          });
          break;
        } else if (!this.validateEmail(obj.email_id?.trim())) {
          validation = false;
          this.setState({
            errorMessage: `email field data incorrect `,
          });
          break;
        } else if (obj.contact_no) {
          if (!contact_regex.test(obj.contact_no)) {
            validation = false;
            this.setState({
              errorMessage: `contact number field data incorrect `,
            });
            break;
          }
        } else if (obj.country_name) {
          if (!this.validateScript(obj.country_name?.trim())) {
            validation = false;
            this.setState({
              errorMessage: `country name field data incorrect `,
            });
            break;
          }
        } else if (obj.location) {
          if (!this.validateScript(obj.location?.trim())) {
            validation = false;
            this.setState({
              errorMessage: `location field data incorrect `,
            });
            break;
          }
        } else if (obj.short_information) {
          if (!this.validateScript(obj.short_information?.trim())) {
            validation = false;
            this.setState({
              errorMessage: `short information field data incorrect `,
            });
            break;
          }
        } else {
          validation = true;
        }
      }
    } else {
      validation = false;
      // this.setState({
      // 	errorMessage: `Blank File with No Records`,
      // });
      return validation;
    }
    return validation; //JSON
  };
  // const onFileUpload = async () => {
  // 	const bodyParam = this.state.uploadData.map((item) => {
  // 		return { ...item, studio_id: this.state.studioSelectedId };
  // 	});
  // 	// alert('bodyParam.length',bodyParam.length)
  // 	if (bodyParam.length > 0) {
  // 		this.setState({ isLoading: true });
  // 		const response = await ajax(
  // 			CONSTANTS.API_METHODS.POST,
  // 			CONSTANTS.API.UPLOADSTUDENT,
  // 			{},
  // 			{},
  // 			bodyParam
  // 		);

  // 		if (response.status === CONSTANTS.STATUS.OK) {
  // 			this.setState({ isLoading: false });
  // 			const { history } = this.props;
  // 			history.push(CONSTANTS.PATHS.STUDENT_STUDIO_ADMIN);
  // 			toast.success(response.message, {
  // 				position: 'bottom-right',
  // 				autoClose: 3000,
  // 				hideProgressBar: true,
  // 				closeOnClick: true,
  // 				pauseOnHover: true,
  // 				draggable: true,
  // 				progress: undefined,
  // 			});
  // 		} else {
  // 			this.setState({ isLoading: false });
  // 			handle_error(response.status);
  // 		}
  // 	} else {
  // 		toast.error(`please select file `, {
  // 			position: 'bottom-right',
  // 			autoClose: 3000,
  // 			hideProgressBar: true,
  // 			closeOnClick: true,
  // 			pauseOnHover: true,
  // 			draggable: true,
  // 			progress: undefined,
  // 		});
  // 	}
  // };
  useEffect(() => {
    traininingCenterFun();
  }, []);
  const setMulticheckbox = (data) => {
    let value = data;
    setUploadedFile((prev) =>
      uploadedFile.includes(value)
        ? prev.filter((cur) => cur?.email_id !== value?.email_id)
        : [...prev, value]
    );
  };

  const gotolistingPage = (training) => {
    navigate(APP_ROUTES.ROUTE_STUDENT, {
      state: {},
    });
  };

  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };

  return (
    <div id="addStudent">
      {console.log("formField----------->>", formField)}
      <div className="mainContainer">
        {showLoader ? (
          <MultiLine_Spinner />
        ) : (
          <>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="TitleContainer"
              container
              justifyContent={"space-between"}
            >
              <div>
                <span className="TitleName" onClick={gotolistingPage}>
                  {" "}
                  {`Student >>`}{" "}
                </span>
                <span className="TrainingName">
                  {type === FOMRS.ADD
                    ? "Add "
                    : type === FOMRS.EDIT
                    ? "Edit "
                    : "View "}
                  Student
                </span>
              </div>
            </Grid>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={1.5}
              className="parentContainer"
            >
              <Stack
                width="100%"
                justifyContent={"flex-end"}
                alignItems="flex-end"
              >
                {type !== FOMRS.ADD && (
                  <div
                    className={
                      editCheckbox
                        ? "edit-add-center-form active_c"
                        : "edit-add-center-form"
                    }
                  >
                    {/* <img
                      src={EDIT}
                      width="55px"
                      height="55px"
                      onClick={(e) => {
                        setEditCheckbox(!editCheckbox);
                        setType(editCheckbox ? "VIEW" : "EDIT");
                      }}
                    /> */}
                  </div>
                )}
              </Stack>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Student Name
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <input
                      placeholder="Student Name"
                      className="addTrainingInput"
                      value={formField?.name}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          name: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          name_error: false,
                        });
                      }}
                    />
                    {formField_error.name_error && (
                      <small className="error small_f">
                        Enter Valid Name *
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Epic Id Username
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <input
                      placeholder="Epic Id Username"
                      className="addTrainingInput"
                      value={formField?.username}
                      disabled={true}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          username: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          username_error: false,
                        });
                      }}
                    />
                    {formField_error.username_error && (
                      <small className="error small_f">
                        Enter Valid Epic Id Username *
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Training Center Name
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    {/* <input
                      className="addTrainingInput"
                      value={name}
                      disabled={true} 
                      // placeholder="Email Address"
                      // onChange={(e) => {
                      // 	setFormField({
                      // 		...formField,
                      // 		email_id: e.target.value,
                      // 	});
                      // 	setFormFild_error({
                      // 		...formField_error,
                      // 		email_id_error: false,
                      // 	});
                      // }}
                    // />
                    {/* <Dropdown
											value={location?.filter(
												(loca) => formField?.location === loca?.value
											)}
											isDisabled={type === FOMRS.VIEW}
											clearable
											options={location}
											onChange={(e) => location_fun(e)}
											selection
											placeholder="Select location"
										/>
										{formField_error.location_error && (
											<small className="error small_f">
												Enter Valid location *
											</small>
										)} */}
                    <Dropdown
                      value={
                        role_code === "STUDIO_ADMIN"
                          ? traininig_center_list
                          : traininig_center_list?.filter(
                              (zone) =>
                                formField?.Training_center_name === zone?.value
                            )
                      }
                      isDisabled={
                        type === FOMRS.VIEW || role_code === "STUDIO_ADMIN"
                      }
                      clearable
                      options={traininig_center_list}
                      onChange={(e) => training_center_fun(e)}
                      selection
                      placeholder="Training Center Name"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Email ID
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <input
                      className="addTrainingInput"
                      value={formField?.email_id}
                      disabled={true}
                      placeholder="Email Address"
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          email_id: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          email_id_error: false,
                        });
                      }}
                    />
                    {formField_error.email_id_error && (
                      <small className="error small_f">
                        Enter Valid Email id *
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Contact no
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <input
                      placeholder="Contact Number"
                      className="addTrainingInput"
                      value={formField?.contact_no}
                      disabled={true}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          contact_no: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          contact_no_error: false,
                        });
                      }}
                    />
                    {formField_error.contact_no_error && (
                      <small className="error small_f">
                        Enter Valid contact no *
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Location
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <Dropdown
                      value={location?.filter(
                        (loca) => formField?.location_id === loca?.value
                      )}
                      isDisabled={type === FOMRS.VIEW}
                      clearable
                      options={location}
                      onChange={(e) => location_fun(e)}
                      selection
                      placeholder="Select location"
                    />
                    {formField_error.location_id_error && (
                      <small className="error small_f">
                        Select Valid location *
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    About Student
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12}>
                    <textarea
                      rows={3}
                      placeholder="Share short Information about the student."
                      className="addTrainingTextarea"
                      value={formField?.short_information}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          short_information: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          short_information_error: false,
                        });
                      }}
                    />
                    {formField_error.short_information_error && (
                      <small className="error small_f">
                        Please enter detail about Student*
                      </small>
                    )}
                  </Grid>
                </Grid>
              </Grid> */}

              {/* {type === FOMRS.VIEW ? (
								''
							) : (
								<Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
									<Grid container>
										<Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
											First download the sample file and then upload file to
											continue
										</Grid>
										<Grid
											container
											direction="row"
											justifyContent="center"
											alignItems="center"
											xs={12}
											sm={12}
											md={12}
											lg={12}
										>
											<Grid item xs={12} sm={12} md={8} lg={8}>
												<Box
													className="add_training_center_uploade_file"
													direction={'row'}
													justifyContent={'center'}
													alignItems={'center'}
												>
													<img src={upload_icon} />
													<Box>
														<label>
															Browse
															<input
																type="file"
																disabled={type === FOMRS.VIEW}
																// onClick={() => handleButtonClick()}
																onChange={onFileChange}
															/>
														</label>
													</Box>
												</Box>
											</Grid>
											<Grid
												item
												xs={12}
												sm={12}
												md={4}
												lg={4}
												className="add_training_center_downlod_file"
											>
												<a
													href={
														type !== FOMRS.VIEW
															? 'https://unreal-engine-ui.s3.ap-south-1.amazonaws.com/instructors_sample_files.csv'
															: undefined
													}
												>
													Download sample file <img src={download_icon} />
												</a>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							)}
							<Grid
								Item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								className="fieldDiv add_training_center_machien_required"
								minHeight={'180px'}
							>
								{uploadedFile &&
									uploadedFile.map((data, i) => {
										{
											console.log('data--------@@@@@@@@@----------->>>', data);
										}
										return (
											<Grid
												className="machine"
												container
												justifyContent={'left'}
												alignItems={'center'}
												direction="row"
												key={i}
											>
												<Grid Item xs={12} sm={1} md={1} lg={1}>
													{type === FOMRS.VIEW ? (
														''
													) : (
														<img
															src={CLOSE}
															style={{ width: '20px' }}
															onClick={() => {
																if (type !== FOMRS.VIEW) {
																	setMulticheckbox(data);
																}
															}}
														/>
													)}
												</Grid>
												<Grid
													Item
													xs={12}
													sm={11}
													md={3}
													lg={3}
													className="small_f"
												>
													<Grid
														container
														justifyContent={'left'}
														alignItems={'center'}
														direction="row"
													>
														<img src={green_icon} />
														<span>{data?.name}</span>
													</Grid>
												</Grid>
												<Grid
													Item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="small_f"
												>
													<Box> {data?.email_id}</Box>
												</Grid>
												<Grid
													Item
													xs={12}
													sm={6}
													md={4}
													lg={4}
													className="small_f"
												>
													<Dropdown
														isDisabled={type === FOMRS.VIEW}
														value={
															data?.zone &&
															getTimeZoneList?.filter(
																(zone) => data?.zone === zone?.key
															)
														}
														clearable
														options={getTimeZoneList}
														onChange={(e) => onTimeZoneChange(e, i)}
														selection
														placeholder="Select Timezone"
													/>
												</Grid>
											</Grid>
										);
									})}
							</Grid> */}

              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                  {type === FOMRS.VIEW ? (
                    <Stack direction={"row"} spacing={1}>
                      <button
                        className="cancelButton"
                        onClick={gotolistingPage}
                      >
                        Back
                      </button>
                    </Stack>
                  ) : (
                    <Stack direction={"row"} spacing={1}>
                      <button
                        className="cancelButton"
                        onClick={gotolistingPage}
                      >
                        Cancel
                      </button>
                      <button className="AddCentreButton" onClick={onSubmit}>
                        Save
                      </button>
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

export default AddTrainingCenterForm;
